<template>
  <div class="dropDown">
    <div class="showLabel">{{selectedItem?selectedItem.name:''}}</div>
    <div class="dropdown-content">
      <ul>
        <li v-for="(item , index) in menuList" :key="index" @click="itemClick(index,item)">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "dropDownMenu",
  model: {
    prop: "selectedItem",
    event: "selected"
  },
  data() {
    return {};
  },
  props: {
    //下拉菜单选项
    menuList: {
      type: Array
    },
    displayName: {
      type: String,
      default() {
        return "name";
      }
    },
    selectedItem: Object
  },
  methods: {
    itemClick: function(index, item) {
      console.log("选择",item);
      if (item == this.selectedItem) return;
      this.$emit("selected", item);
      this.$emit("selectChange", item);
    }
  },
  watch: {},
  created() {}
};
</script>

<style scoped>
@keyframes slide-down {
  0% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes slide-up {
  0% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 0);
  }
}

/* @-webkit-keyframes slide-down {
   0% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
} */

.dropDown {
  background-color: #fff;
  position: relative;
  width: 88px;
  height: 20px;
}

.dropdown-content {
  display: none;
  position: absolute;
  /* height: 150px; */
  min-width: 88;
  border-radius: 6px;
  box-shadow: 0px 3px 7px 0px rgba(66, 79, 97, 0.15);
  background-color: #ffffff;
  z-index: 2;
  left: calc(50% - 44px);
  overflow: hidden;
  top: 100%;
}

.dropDown:hover .dropdown-content {
  display: block;
  transform-origin: 0 0;
  animation: slide-down 0.15s ease-in;
}

.showLabel {
  text-align: center;
  font-size: 12px;
  color: #474261;
  font-weight: bold;
  height: 14px;
  margin: 0;
}

.showLabel:hover {
  cursor: pointer;
}

.showLabel:after {
  content: "";
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #474261;
  border-right: 1px solid #474261;
  position: absolute;
  margin-left: 5px;
  margin-top: 2px;
  transform-origin: center center;
  transform: rotate(45deg);
}

.dropdown-content li {
  /* padding: 9px 20px; */
  width: 88px;
  height: 30px;
  font-size: 12px;
  color: #474261;

  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdown-content li:hover {
  background-color: #f0f0f8;
  cursor: pointer;
}
.dropdown-content li span {
}
</style>


// WEBPACK FOOTER //
// src/components/emodal/templateLib/dropDownMenu.vue